import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHFeriadoDel = async (credentials, data) => {
  const body = {
    service: "RNHFeriadoDel",
    params: {
      rnhFeriadoId: data?.id || null,
      rnhFeriadoVersion: data?.version ?? null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
